"use client";

import React from "react";
import { Leaf, Map, Globe, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Projetos de Engenharia",
  description: "Desenvolvimento de sistemas HVAC customizados com foco em eficiência energética, dimensionamento preciso e total conformidade técnica.",
  icon: Map,
  link: "/SolutionsPage"
}, {
  title: "Retrofit e Modernização",
  description: "Atualização tecnológica de instalações existentes para redução drástica de custos operacionais e menor impacto ambiental.",
  icon: Leaf,
  link: "/SolutionsPage"
}, {
  title: "Manutenção Especializada",
  description: "Gestão de ativos com planos preventivos e preditivos que garantem a continuidade operacional e a máxima vida útil dos equipamentos.",
  icon: Globe,
  link: "/SolutionsPage"
}];
export default function TheoryFoundations() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="152452" id="serviços" className="bg-secondary-100 text-foreground py-24 px-4 md:px-8 lg:px-12 overflow-hidden bg-[linear-gradient(to_right,theme(colors.primary/2%)_1px,transparent_1px),linear-gradient(to_bottom,theme(colors.primary/2%)_1px,transparent_1px)] bg-[size:40px_40px]">
      <div className="max-w-7xl mx-auto">
        <div className="mb-16 text-center max-w-2xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-default font-bold text-foreground mb-4 tracking-tight">
            Nossos Serviços
          </h2>
          <p className="text-foreground/70 text-lg font-sans">
            Engenharia de precisão e soluções térmicas inteligentes para o seu empreendimento.
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-3 gap-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
          {services.map((service, i) => {
          const Icon = service.icon;
          return <div data-index={i} key={i} className="h-full">
                <Card className="h-full flex flex-col bg-transparent border-b border-primary/20 border-t-0 border-x-0 rounded-none hover:bg-white/40 transition-all duration-300 shadow-none">
                  <CardHeader className="pb-4">
                    <div className="size-12 rounded-none bg-transparent flex items-center justify-center mb-4 text-primary">
                      <Icon className="size-12" strokeWidth={1} />
                    </div>
                    <CardTitle className="font-default text-2xl font-bold leading-tight text-foreground">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="flex-grow">
                    <CardDescription className="text-base text-foreground/80 leading-relaxed font-sans">
                      {service.description}
                    </CardDescription>
                  </CardContent>
                  <CardFooter className="pt-4 pb-8">
                    <Button asChild variant="ghost" className="group text-primary hover:text-primary-600 hover:bg-primary/5 -ml-4 font-sans font-bold">
                      <Link to={service.link}>
                        Saiba Mais
                        <ArrowRight className="ml-2 size-4 transition-transform group-hover:translate-x-1" />
                      </Link>
                    </Button>
                  </CardFooter>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}